import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  styled,
  Table,
  TableCell,
  TableHead,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

export const StyleTable = styled(Table)(() => ({
  marginTop: '10px',
  width: '100%',
  minWidth: '500px',
}));

export const StyleTableHead = styled(TableHead)(() => ({
  background: '#e5e7eb',
  '& th': {
    whiteSpace: 'nowrap',
  },
}));

/** 44px control + reserved helper row — row height stays fixed when validating */
const TABLE_FIELD_CONTROL_H = "44px";
const TABLE_FIELD_HELPER_H = "18px";

export const StyleTableFieldWrap = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  justifyContent: "flex-start",
  width: "100%",
  minHeight: `calc(${TABLE_FIELD_CONTROL_H} + ${TABLE_FIELD_HELPER_H})`,
  boxSizing: "border-box",
  "& .MuiTextField-root, & .MuiAutocomplete-root": {
    width: "100%",
    margin: 0,
  },
}));

export const StyleTableCell = styled(TableCell)(() => ({
  paddingTop: "8px",
  paddingBottom: "8px",
  verticalAlign: "top",
  "& > *": {
    width: "100%",
  },
}));

export const StyleTableActionCell = styled(StyleTableCell)(() => ({
  position: "relative",
  verticalAlign: "middle",
  textAlign: "center",
  width: "10%",
  minWidth: 72,
  paddingLeft: 8,
  paddingRight: 8,
}));

export const StyleTableActionButtonWrap = styled(Box)(() => ({
  position: "absolute",
  top: "36%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
export const StyleTableActionHeaderCell = styled(TableCell)(() => ({
  textAlign: "center",
  width: "10%",
  minWidth: 72,
  whiteSpace: "nowrap",
}));

export const IconButtonStyle = styled(IconButton)(() => ({
  marginTop: "40px",
}));

export const StyleTableIconButton = styled(IconButton)(() => ({
  margin: 0,
  padding: 8,
}));

export const StyledBoxV2 = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

// export const StyledBoxV2 = styled(Box)(({ theme }) => ({
//   position: "absolute",
//   top: 0,
//   left: 0,
//   width: "100vw",      // Full screen width
//   height: "100vh",     // Full screen height
//   maxHeight: "100vh",  // Prevent overflow
//   overflow: "auto",
//   background: theme.palette.custom.virtualSuccess,
//   borderRadius: 0,     // No rounded corners for fullscreen
//   color: theme.palette.custom.white,
//   outline: "none",

//   [theme.breakpoints.down("md")]: {
//     width: "100vw",
//     height: "100vh",
//   },
//   [theme.breakpoints.down("sm")]: {
//     width: "100vw",
//     height: "100vh",
//   },
//   [theme.breakpoints.down("xs")]: {
//     width: "100vw",
//     height: "100vh",
//   },
// }));


export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(759px, calc(100vw - 24px))",
  maxWidth: "calc(100vw - 24px)",
  maxHeight: "95vh",
  overflow: "auto",
  background: theme.palette.custom.virtualSuccess,
  borderRadius: theme.borderRadius.radius.large,
  color: theme.palette.custom.white,

  outline: "none",

  [theme.breakpoints.down("md")]: {
    width: "calc(100vw - 24px)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "calc(100vw - 16px)",
  },
  [theme.breakpoints.down("xs")]: {
    width: "calc(100vw - 16px)",
  },
}));

export const StyledMain = styled(Box)(() => ({
  padding: "0px 24px 24px 24px",
  overflow: "auto",
}));
export const ModalHeader = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
export const StyledBoxGap = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "10px 10px",
  marginBottom: "38px",
}));
export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  color: theme.palette.custom.productTextColor,
  marginTop: "18px",
}));
export const StyledTypographyDetails = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.virtualTitle,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  paddingLeft: "50px",
  [theme.breakpoints.down("md")]: {
    paddingLeft: "0px",
  },
}));
export const StyledTypographyInformation = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.uploadColor,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  paddingRight: "15px",

  [theme.breakpoints.down("sm")]: {
    paddingRight: "0px",
    textAlign: "end",
  },
}));
export const StyledTypographyOrder = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.OrderTextColor,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  padding: "18px 0px",
}));
export const StyledBoxBorder = styled(Box)(({ theme, colorBg }) => ({
  background: colorBg
    ? theme.palette.custom.startInputBgColor
    : theme.palette.custom.uploadColor,
  width: "200px",
  height: "2px",
  [theme.breakpoints.down("md")]: {
    width: "160px",
  },
}));
export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.xLarge.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  paddingTop: "24px",

  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.mini.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
  paddingTop: "12px",
}));
export const ButtonWrapper = styled(Box)(() => ({
  paddingTop: "24px",
  width: "141px",
}));
export const CloseBtn = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  cursor: "pointer",
})); export const StyledAssistantTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.productTextColor,
  fontSize: theme.typography.small.fontSize

}));
export const StyledTypographyEnter = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.profileSuccessDes,
}));
export const StyledBoxWrapper = styled(Box)(() => ({
  marginTop: "42px",
  display: "flex",
  justifyContent: "flex-end",
}));
export const StyledBoxWrapperButton = styled(Box)(() => ({
  display: "flex",
  marginTop: "37px",
  justifyContent: "flex-end",
  bottom: 0,
  position: 'sticky',
}));
export const StyledBoxStart = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  height: 44,
  borderTopLeftRadius: theme.borderRadius.radius.wallet,
  borderBottomLeftRadius: theme.borderRadius.radius.wallet,
  background: theme.palette.custom.searchBg,
  border: theme.borders.boxBorder,
  marginRight: "8px",
}));
const vlFormOutlinedInputSx = (theme, height = "48px") => ({
  height,
  minHeight: height,
  maxHeight: height,
  borderRadius: theme.borderRadius.radius.wallet,
  background: theme.palette.custom.white,
  boxSizing: "border-box",
  padding: "0 10px !important",
  "& .MuiInputBase-input": {
    padding: "0 !important",
    height: "24px",
    minHeight: "24px",
    lineHeight: "24px",
    boxSizing: "border-box",
  },
  "& .MuiAutocomplete-input": {
    padding: "0 !important",
  },
  "& .MuiAutocomplete-endAdornment": {
    top: "50%",
    transform: "translateY(-50%)",
    right: "8px",
  },
});

/** Same 48px inputs as Time dropdown across all virtual-locker tabs */
export const StyleBoxContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.regular,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
  padding: "12px",
  overflowX: "auto",

  "& .MuiGrid2-root > .MuiBox-root:not([data-vl-location-row])": {
    paddingTop: "0 !important",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  },

  "& [data-vl-location-row]": {
    display: "grid !important",
    width: "100%",
    paddingTop: "0 !important",
  },

  "& .MuiOutlinedInput-root": vlFormOutlinedInputSx(theme, "48px"),

  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    ...vlFormOutlinedInputSx(theme, "48px"),
    "&.Mui-focused": vlFormOutlinedInputSx(theme, "48px"),
  },

  "& .MuiTable-root .MuiOutlinedInput-root": vlFormOutlinedInputSx(theme, "44px"),

  "& .MuiTable-root .MuiAutocomplete-root .MuiOutlinedInput-root": {
    ...vlFormOutlinedInputSx(theme, "44px"),
    "&.Mui-focused": vlFormOutlinedInputSx(theme, "44px"),
  },

  "& .MuiTable-root .MuiButton-root, & .MuiTable-root label .MuiButton-root": {
    minHeight: "44px",
    height: "44px",
    maxHeight: "44px",
    boxSizing: "border-box",
  },

  "& label .MuiButton-root:not(.MuiTable-root label .MuiButton-root)": {
    minHeight: "48px",
    height: "48px",
    maxHeight: "48px",
    boxSizing: "border-box",
  },

  "& .MuiTable-root .MuiTableCell-root .MuiBox-root": {
    paddingTop: "0 !important",
  },

  "& .MuiFormHelperText-root": {
    minHeight: "16px",
    margin: "2px 0 0",
    lineHeight: "16px",
    display: "block",
    marginLeft: 0,
  },

  "& .MuiTable-root .MuiFormHelperText-root": {
    minHeight: `${TABLE_FIELD_HELPER_H} !important`,
    height: TABLE_FIELD_HELPER_H,
    maxHeight: TABLE_FIELD_HELPER_H,
    margin: "2px 0 0",
    lineHeight: TABLE_FIELD_HELPER_H,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
    boxSizing: "border-box",
  },

  '& input[type="date"]': {
    lineHeight: "24px",
  },
}));

/** Aligns profile-style fields in a grid with equal input heights */
export const StyledPersonalShopperFieldGrid = styled(Grid)(({ theme }) => ({
  alignItems: "flex-start",
  "& > .MuiGrid2-root": {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },
  "& .MuiFormHelperText-root:empty": {
    minHeight: 0,
    margin: 0,
  },
}));

export const StyledFormGridCell = styled(Grid)(() => ({
  display: "flex",
  alignItems: "stretch",
  "& > *": {
    width: "100%",
  },
}));
export const StyledTypographyRup = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.startInputColor,
  padding: "10px 16px",
  textAlign: "center",
}));
export const StyledInputAdornment = styled(InputAdornment)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  background: theme.palette.custom.searchBg,
  margin: "0px",
}));
export const StyledGrid = styled(Grid)(({ theme, isactive }) => ({
  color:
    isactive === true
      ? theme.palette.custom.white
      : theme.palette.custom.orderCards,
  border: "1px solid #D6D8D9",
  display: "flex",
  justifyContent: "center",
  height: "50px",
  alignItems: "center",
  borderRadius: theme.borderRadius.radius.wallet,
  backgroundColor:
    isactive === true
      ? theme.palette.custom.primary
      : theme.palette.custom.white,
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
  whiteSpace: "nowrap",
  flex: "0 0 auto",
  width: "auto",
  minWidth: "170px",
  [theme.breakpoints.down("sm")]: {
    minWidth: "170px",
    padding: "14px 18px",
  },
}));
export const StyledBoxUpload = styled(Box)(({ theme }) => ({
  height: "198px",
  display: "flex",
  gap: "18px",
  cursor: "pointer",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  backgroundColor: theme.palette.custom.white,
  border: "1px solid #D6D8D9",
  borderRadius: theme.borderRadius.radius.wallet,
}));
export const StyledTypographyProduct = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  color: theme.palette.custom.uploadProductColor,
}));
export const StyledDivider = styled(Divider)(() => ({
  marginTop: "30px",
  marginBottom: "30px",
}));
export const StyledBoxButton = styled(Box)(() => ({
  marginTop: "24px",
}));

export const StyledUploadField = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasfile" && prop !== "uploaddisabled" && prop !== "haserror",
})(({ theme, hasfile, uploaddisabled, haserror }) => ({
  display: "block",
  width: "100%",
  maxWidth: "100%",
  minWidth: "140px",
  borderRadius: theme.borderRadius.radius.wallet,
  border: `1px solid ${haserror ? theme.palette.custom.danger : hasfile ? theme.palette.custom.primary : "#D6D8D9"}`,
  background: theme.palette.custom.white,
  opacity: uploaddisabled ? 0.72 : 1,
  overflow: "hidden",
}));

export const StyledUploadButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "hasfile",
})(({ theme, hasfile }) => ({
  textTransform: "none",
  justifyContent: "flex-start",
  gap: "8px",
  fontWeight: theme.typography.fontWeight.medium,
  borderRadius: theme.borderRadius.radius.wallet,
  borderColor: "transparent",
  color: hasfile ? theme.palette.custom.primary : "#9AA0A6",
  background: "transparent",
  padding: "0 8px",
  minHeight: "48px",
  height: "48px",
  width: "100%",
  fontSize: "0.8125rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  "& .MuiButton-startIcon": {
    marginRight: "4px",
    marginLeft: 0,
  },
  "& .MuiButton-startIcon > *:nth-of-type(1)": {
    fontSize: "1.1rem",
  },
  "&:hover": {
    borderColor: "transparent",
    background: theme.palette.custom.white,
  },
}));
export const StyledUploadWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

export const StyledUploadLabel = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  minHeight: "32px",
  lineHeight: 1.25,
  marginBottom: "4px",
  display: "flex",
  alignItems: "flex-end",
  color: theme.palette.custom.productTextColor,
  "& span": {
    color: theme.palette.custom.danger,
  },
}));

export const StyledUploadFileLabel = styled("label")(() => ({
  cursor: "pointer",
  width: "100%",
  display: "block",
}));

export const StyledUploadErrorText = styled("p")(({ theme }) => ({
  color: theme.palette.error?.main || "#d32f2f",
  fontSize: "0.75rem",
  marginTop: "3px",
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontFamily: "inherit",
  fontWeight: 400,
  lineHeight: 1.66,
  display: "block",
}));

export const StyledInputGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  marginTop: "20px",
  [theme.breakpoints.down("md")]: {
    marginTop: "0px",
  },
}));
export const StyledBoxCard = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.primary,
  display: "flex",
  justifyContent: 'space-between',
  padding: "13px 25px",
  alignItems: "center",
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
  position: "sticky",
  top: 0,
  zIndex: 10,
}));
